import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/home/Home.vue";

import Login from "../views/login/Login.vue";
import ForgotPassword from "../views/login/ForgotPassword.vue";
import ResetPassword from "../views/login/ResetPassword.vue";

import Tabs from "../views/menu_pages/TabSettings";
import Blacklist from "../views/menu_pages/Blacklist";
import Groups from "../views/menu_pages/Groups";
import Admin from "../views/menu_pages/Admin";
import Export from "../views/menu_pages/Export";

import NotFound from "../views/notfound/NotFound";
import UserProfile from "../views/menu_pages/UserProfile";
import Label from "@/views/menu_pages/Label";
import Controlling from "@/views/menu_pages/Controlling";

Vue.use(VueRouter);

export default new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "Home",
            component: Home
        },
        {
            path: "/login",
            name: "Login",
            component: Login
        },
        {
            path: "/login/forgot-password",
            name: "ForgotPassword",
            component: ForgotPassword
        },
        {
            path: "/login/reset-password",
            name: "ResetPassword",
            component: ResetPassword
        },
        {
            path: "/tabconfig",
            name: "Tabs",
            component: Tabs,
            meta: {
                title: "LuPS | Kartenreiter"
            }
        },
        {
            path: "/blacklist",
            name: "Blacklist",
            component: Blacklist,
            meta: {
                title: "lupus | Ausgeblendete Artikel"
            }
        },
        {
            path: "/groups",
            name: "Groups",
            component: Groups,
            meta: {
                title: "LuPS | Apothekengruppen"
            }
        },
        {
            path: "/export",
            name: "Export",
            component: Export,
            meta: {
                title: "LuPS | Export"
            }
        },
        {
            path: "/label",
            name: "Label",
            component: Label,
            meta: {
                title: "LuPS | Etiketten"
            }
        },
        {
            path: "/admin",
            name: "Admin",
            component: Admin,
            meta: {
                title: "LuPS | Administrationsbereich"
            }
        },
        {
            path: "/controlling",
            name: "Controlling",
            component: Controlling,
            meta: {
                title: "LuPS | Controlling Tool"
            }
        },
        {
            path: "/me",
            name: "Me",
            component: UserProfile,
            meta: {
                title: "LuPS | Profil"
            }
        },
        {
            path: "*",
            component: NotFound
        }
    ]
});
